export default __webpack_public_path__ + "static/media/CIP_potato_panel.3155d012.jpeg";